<div class="modal">
  <header class="header">
    @if (userProfile()?.avatar; as avatar) {
      <evc-avatar
        [avatar]="avatar"
        size="xl"
        class="user-avatar" />
    }
    <p class="title">{{ welcome() }}</p>
    <p class="email">{{ userProfile()?.email }}</p>
  </header>

  <div class="divider-box">
    <div class="divider-bar"></div>
  </div>

  <section class="organizations">
    <p class="subtitle">
      {{ ('auth-organization-selection-modal.choose_org' | platformTranslate)() }}
    </p>
    @for (org of organizations(); track org.id) {
      <button
        class="org-item"
        [class.org-item--disabled]="!org.hasAccess"
        [disabled]="!org.hasAccess || undefined"
        (click)="orgSelected.emit(org.id)">
        <evc-avatar
          size="md"
          [avatar]="org.avatar" />
        <div class="org-item__text">
          <span class="org-item__name">{{ org.name }}</span>
          <span class="org-item__role">{{ org.additionalText }}</span>
        </div>
      </button>
    }
  </section>

  <div class="divider-box">
    <div class="divider-bar"></div>
  </div>

  <button
    class="org-item org-item__account"
    (click)="useAnotherAccount.emit()">
    <evc-avatar
      size="md"
      [avatar]="useAnotherAccountAvatar" />
    <span class="org-item__name">{{
      ('auth-organization-selection-modal.use_another_account' | platformTranslate)()
    }}</span>
  </button>
  <button
    class="org-item org-item__logout"
    (click)="logout()">
    <evc-avatar
      size="md"
      [avatar]="logoutAvatar" />
    <span class="org-item__name">{{
      ('auth-organization-selection-modal.logout' | platformTranslate)()
    }}</span>
  </button>
</div>
